<template>
	<card class="edit-card">
		<loader :loading="loading"></loader>
		<h4 class="title">
			<slot name="title"></slot>
			<transition name="fade" mode="out-in">
				<div class="actions" v-if="user.can(permission) && !editing && !editOnly" key="edit-actions">
					<icon-action @click="editing = true">essentials/settings/edit-circle</icon-action>
				</div>
				<div class="actions" v-else-if="user.can(permission) && (editing || editOnly)" key="save-actions">
					<icon-action @click="editing = false; $emit('cancel')" v-if="!editOnly">essentials/basics/close-circle</icon-action>
					<icon-action @click="doSave">essentials/basics/check-circle</icon-action>
				</div>
			</transition>
		</h4>
		<transition name="fade" mode="out-in">
			<div class="content" v-if="!editing && !editOnly" key="view-content">
				<slot name="view"></slot>
			</div>
			<div class="content" v-else key="edit-content" @keyup.enter.prevent.stop="doSave">
				<slot name="edit"></slot>
			</div>
		</transition>
	</card>
</template>

<script>
	export default {
		props: ['permission', 'save', 'editOnly'],
		data() {
			return {
				editing: false,
				loading: false
			};
		},
		computed: {
			user() {
				return this.$store.state.user;
			}
		},
		methods: {
			async doSave() {
				if(this.loading) {
					return;
				}
				this.loading = true;
				try {
					await this.save();
					this.editing = false;
				} catch(e) {}
				this.loading = false;
			}
		}
	}
</script>